import { VFadeTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"page-transition"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }